import React from "react";

const UDISEPortal = () => {
    return (
        <div>
            <h2>UDISE Portal</h2>
            <p>This is the UDISE Portal tab. Add your portal update features here.</p>
        </div>
    );
};

export default UDISEPortal;

